<script setup lang="ts">
import {ref, nextTick} from "vue";
import {VideoService} from "@/api/api.ts";
import {ElNotification} from "element-plus";

let player: Aliplayer;
const visible = ref(false);
const videoId = ref("")
const videoType = ref("")
const transformComplete = ref(false);
// 扩展 `window` 对象的类型
declare global {
    interface Window {
        polyvPlayer: any; // 这里使用 `any` 类型，你可以根据实际的 `polyvPlayer` API 类型做进一步的细化
    }
}
const initVideoPlayer = async () => {
    if(videoType.value == '1'){
        try {
            const statusRes = await VideoService.getVideoStatus({
                video_id: videoId.value
            })
            if (statusRes.data.code === 200) {
                if (statusRes.data.data === 1) {
                    transformComplete.value = true
                    await nextTick()
                    // 转码完成，获取播放凭证
                    await getAuth()
                } else {
                    // 转码中
                    transformComplete.value = false
                }
            } else {
                ElNotification.error({
                    title: '获取视频转码状态失败',
                    message: statusRes.data.msg,
                    type: 'error',
                })
            }
        } catch (error) {
            console.warn(error)
        } finally {
        }
    }else{
        // const script = document.createElement('script');
        // script.src = '//player.polyv.net/resp/vod-player/latest/player.js'; // 外部 JS 文件的 URL
        // script.onload = () => {
        //     console.log('外部 JS 文件加载完成');
        //     initializePlayer(); // 文件加载完成后初始化播放器
        // };
        // document.body.appendChild(script);

        loadPlayerScript(loadPlayer);
    }
}

const loadPlayerScript = (callback: () => void) => {
    const vodPlayerJs = 'https://player.polyv.net/resp/vod-player/latest/player.js';
    if (!window.polyvPlayer) {
        const myScript = document.createElement('script');
        myScript.setAttribute('src', vodPlayerJs);
        myScript.onload = callback;
        document.body.appendChild(myScript);
    } else {
        callback();
    }
};

const loadPlayer = () => {
    const player = ref<any>(null);
    const polyvPlayer = window.polyvPlayer;
    player.value = polyvPlayer({
        wrap: '#plvideo',
        // width: 800,
        // height: 533,
        vid: videoId.value, // 视频 ID
        playsafe: '', // 播放加密视频的凭证 (可以根据需要传入)
        code: 'myCodeValue', // 可以传入自定义的code（如果需要）
    });
};


// const loadPlayerScript = (callback: () => void): void => {
//     const vodPlayerJs = ref("https://player.polyv.net/resp/vod-player/latest/player.js")
//     const myScript = document.createElement('script');
//     myScript.setAttribute('src', vodPlayerJs.value);
//     myScript.onload = callback;
//     document.body.appendChild(myScript);
// }
// const loadPlayer = () => {
//     const polyvPlayer = window.polyvPlayer;
//     polyvPlayer({
//         wrap: '#plvideo', // 播放器容器 ID
//         // width: '600', // 宽度
//         // height: '338', // 高度
//         vid: videoId.value, // 视频 ID
//         playsafe: '', // 播放加密视频的凭证 (可以根据需要传入)
//         code: 'myCodeValue', // 可以传入自定义的code（如果需要）
//     });
// }



const getAuth = async () => {
  try {
    const res = await VideoService.getPlayAuth({
      video_id: videoId.value
    })
    if (res.data.code === 200) {
      const options: PlayerOption = {
        id: "player-con",
        width: "100%",
        height: "600px",
        autoplay: true,
        vid: videoId.value,
        playauth: res.data.data?.PlayAuth,
        cover: res.data.data?.CoverURL,
        encryptType: 1,
      }
      player = new Aliplayer(options)
    } else {
      ElNotification.error({
        title: '获取播放凭证失败',
        message: res.data.msg,
        type: 'error',
      })
    }
  } catch (error) {
    console.warn(error)
  } finally {
  }
}

const disposeVideo = () => {
  if (player) {
    player.dispose();
  }
}

const show = (_videoId: string,_type:string) => {
  videoId.value = _videoId
  videoType.value = _type
  visible.value = true;
  initVideoPlayer()
}

const hide = () => {
  visible.value = false;

}

const onClose = () => {
  disposeVideo()

    if(videoType.value == '2'){
        const polyvPlayer = window.polyvPlayer;
        const playerP = polyvPlayer({
            wrap: '#plvideo', // 播放器容器 ID
        });
        playerP.destroy();
    }

}


defineExpose({
  show, hide
})
</script>

<template>
  <el-dialog v-model="visible" width="40%"  align-center title="视频播放" @close="onClose">
      <div v-if="videoType == '1'">
          <div id="player-con" ref="playerCon" v-if="transformComplete">
          </div>
          <div v-else class="text-1.5rem">
              该视频正在转码中
          </div>
      </div>
      <div v-else>
          <div id='plvideo'>
          </div>
      </div>



  </el-dialog>
</template>

<style scoped>
</style>
